module.exports = __webpack_public_path__ + "img/1512882937.4f16b867.jpg";